export const menuList = [
  {
    id: "stff",
    primary: "スタッフ",
    children: [
      ["訪問予定", ["/day_schedule", "/instructions"]],
      ["予定変更", ["/edit_schedule"], "adminFg"],
      ["スケジュール", ["/schedules"]],
      ["シフト", ["/shifts"]]
    ]
  }
];
